import React, {Component} from "react";
import {logout} from "../../data/actions/user";

export default class Logout extends Component {

    render() {
        return (
            <React.Fragment>
                <span title={this.props.title} className={"cursor-pointer " + this.props.className} onClick={() => {
                    this.props.dispatch(logout({}));
                }}>
                    {this.props.translate("app.logout")}
                </span>
            </React.Fragment>
        )
    }
}